<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc-title">CONTENTS</h2>
<p class="toc-chaptert"><a href="#/xhtml/fm02">Foreword</a></p>
<p class="toc-chapter"><a href="#/xhtml/fm03">SOUL SENSE</a></p>
<p class="toc-chapter"><a href="#/xhtml/fm04">Introduction</a></p>
<p class="toc-chaptert"><span href="#/xhtml/chap01" title="Link target outside of Sample">Chapter 1: Connecting the Dots, Weaving the Threads</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap02" title="Link target outside of Sample">Chapter 2: Soul Call, Soul Fire, Soul Care: An Overview</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap03" title="Link target outside of Sample">Chapter 3: Soul Call</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap04" title="Link target outside of Sample">Chapter 4: Soul Fire</span></p>
<p class="toc-chapter"><span href="#/xhtml/chap05" title="Link target outside of Sample">Chapter 5: Soul Care</span></p>
<p class="toc-section"><span href="#/xhtml/chap05#sec1" title="Link target outside of Sample">The Eleven Golden Threads</span></p>
<p class="toc-chapter"><span href="#/xhtml/bm01" title="Link target outside of Sample">Closing Thoughts</span></p>
<p class="toc-section"><span href="#/xhtml/bm01#sec1" title="Link target outside of Sample">A Call to Choose</span></p>
<p class="toc-chaptert"><span href="#/xhtml/bm02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-chapter"><span href="#/xhtml/bm03" title="Link target outside of Sample">About Adrienne Duffy</span></p>
<p class="toc-chapter"><span href="#/xhtml/bm04" title="Link target outside of Sample">Soul Sense: Taking Action</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2e6dd9ce